// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8407":"d69dc00d","8738":"9b98a338"}[chunkId] + ".chunk.css";
};